import { render, staticRenderFns } from "./AllotDialog.vue?vue&type=template&id=a908219c&scoped=true"
import script from "./AllotDialog.vue?vue&type=script&lang=js"
export * from "./AllotDialog.vue?vue&type=script&lang=js"
import style0 from "./AllotDialog.vue?vue&type=style&index=0&id=a908219c&prod&scoped=true&lang=css"
import style1 from "./AllotDialog.vue?vue&type=style&index=1&id=a908219c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a908219c",
  null
  
)

export default component.exports